var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgOv10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72516 2.45313C11.4719 1.73551 14.1617 0.981783 16.7172 0.269525C19.3467 -0.475534 21.7677 0.340217 23.4269 2.51581C25.0465 4.62082 26.7472 6.8446 28.5116 9.0666C30.307 11.3678 31.1988 14.2814 30.5449 16.6643C29.903 19.011 29.132 21.3148 28.2316 23.5757C27.3141 25.871 24.8458 27.6684 22.0337 28.4274C19.287 29.145 16.5972 29.8987 14.0417 30.611C11.4122 31.3561 8.99121 30.5403 7.33195 28.3647C5.71238 26.2597 4.01173 24.0359 2.24735 21.8139C0.45188 19.5127 -0.439882 16.5991 0.213994 14.2162C0.855849 11.8695 1.62694 9.5657 2.52726 7.30485C3.44477 5.00952 5.91305 3.21216 8.72516 2.45313Z",
    fill: "#FF6C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgOv10);
export default __webpack_public_path__ + "static/media/prog-ov-10.6786dad199dd3cf8ed9d1481ceffaf6f.svg";
export { ForwardRef as ReactComponent };